import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/Section";
import { Calendar, MapPin } from "lucide-react";

export default function Events() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="events-page">
      <PageHeader eyebrow="APPOINTED TIMES" title="Events & Feasts"
        subtitle="Join us for weekly worship, the moedim, and special gatherings."
        bg="https://images.unsplash.com/photo-1570786032462-2efc3ca8fccd?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80" />
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          {items.length === 0 ? <EmptyState title="No upcoming events." /> : (
            <div className="space-y-6">
              {items.map((e) => (
                <article key={e.id} data-testid={`event-${e.id}`} className="border hairline rounded-xl overflow-hidden surface grid grid-cols-1 md:grid-cols-[280px_1fr]">
                  {e.image_url && <img src={e.image_url} alt={e.title} className="w-full h-full object-cover aspect-video md:aspect-auto" />}
                  <div className="p-7">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="font-accent text-[10px] text-gold flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {new Date(e.date).toLocaleString(undefined, { dateStyle: "full", timeStyle: "short" })}</span>
                    </div>
                    <h3 className="font-display text-2xl text-white">{e.title}</h3>
                    <p className="mt-1 text-sm text-zinc-400 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-gold" /> {e.location}</p>
                    <p className="mt-4 text-zinc-300 leading-relaxed">{e.description}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
